import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";
import { isEmpty } from "utils/Utils";

import { Link } from "@mui/material";
import { UrlField } from "../FieldService";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type UrlInputProps = {
	field: UrlField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const UrlInput: React.FC<UrlInputProps> = (props: UrlInputProps) => {
	function isValid(value: string): boolean {
		return props.field.required ? !isEmpty(value) : true;
	}

	function resolveLink(): string {
		const link = props.field.value;
		if (link.startsWith("http://") || link.startsWith("https://")) {
			return link;
		} else {
			return "https://" + link;
		}
	}

	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<Grid item>
			<Typography>{props.field.name}</Typography>
			<ManagedTextField
				id={props.field.name}
				fullWidth
				disabled={
					!props.editable ||
					props.rights[toId(props.field.uuid)][
						InformationRight.WRITE
					] === false
				}
				required={props.field.required}
				error={!isValid(props.field.value)}
				value={props.field.value}
				onUpdate={value => props.onChange(props.field.uuid, value)}
			/>
			<Link
				variant="subtitle1"
				href={resolveLink()}
				target="_blank"
				rel="noopener noreferrer">
				{props.field.value}
			</Link>
		</Grid>
	);
};

export default UrlInput;
